import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=603f7a67&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"
import style0 from "./Start.vue?vue&type=style&index=0&id=603f7a67&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603f7a67",
  null
  
)

export default component.exports